export default "__VITE_ASSET__B$Xijc4o__"